import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiType, FiUser } = FiIcons;

function QuoteInput({ onSubmit, initialQuote = '', initialAuthor = '', onQuoteChange, onAuthorChange }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (initialQuote.trim()) {
      onSubmit(initialQuote.trim(), initialAuthor.trim());
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-8"
      >
        <h2 className="text-3xl font-bold text-gray-900 mb-3">
          Create Your Quote Poster
        </h2>
        <p className="text-lg text-gray-600">
          Enter your favorite quote or pick one from the feed below
        </p>
      </motion.div>

      <motion.form
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        onSubmit={handleSubmit}
        className="bg-white rounded-2xl shadow-xl p-8 space-y-6 border border-slate-100"
      >
        <div>
          <label className="flex items-center space-x-2 text-sm font-semibold text-gray-700 mb-3">
            <SafeIcon icon={FiType} className="w-4 h-4" />
            <span>Your Quote</span>
          </label>
          <textarea
            value={initialQuote}
            onChange={(e) => onQuoteChange(e.target.value)}
            placeholder="Enter your inspiring quote here..."
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none transition-colors"
            rows={4}
            required
          />
          <div className="text-right mt-1">
            <span className={`text-sm ${initialQuote.length > 200 ? 'text-red-500' : 'text-gray-400'}`}>
              {initialQuote.length}/200
            </span>
          </div>
        </div>

        <div>
          <label className="flex items-center space-x-2 text-sm font-semibold text-gray-700 mb-3">
            <SafeIcon icon={FiUser} className="w-4 h-4" />
            <span>Author (Optional)</span>
          </label>
          <input
            type="text"
            value={initialAuthor}
            onChange={(e) => onAuthorChange(e.target.value)}
            placeholder="Quote author or your name"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-colors"
          />
        </div>

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          type="submit"
          disabled={!initialQuote.trim()}
          className="w-full bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 disabled:from-gray-300 disabled:to-gray-400 text-white py-4 rounded-xl font-semibold flex items-center justify-center space-x-2 transition-all disabled:cursor-not-allowed shadow-lg shadow-indigo-200"
        >
          <span>Choose Style</span>
          <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
        </motion.button>
      </motion.form>
    </div>
  );
}

export default QuoteInput;